import { z } from 'zod';

/**
 * Item categories — a per-tenant tree (each category may have a parent),
 * each optionally carrying a photo (stored via the generic attachments API
 * with entityType='category'). Items reference one category via categoryId.
 */
export const CategorySchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  code: z.string().min(1).max(64),
  name: z.string().min(1).max(200),
  description: z.string().nullable(),
  parentId: z.string().uuid().nullable(),
  /** Running order among siblings — lower first, ties by code. Same idea as brands.sort. */
  sort: z.number().int(),
  isActive: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type Category = z.infer<typeof CategorySchema>;

export const CategoryCreateSchema = z.object({
  code: z.string().min(1).max(64),
  name: z.string().min(1).max(200),
  description: z.string().max(2000).optional(),
  parentId: z.string().uuid().optional(),
  sort: z.number().int().min(0).max(1_000_000).optional(),
});
export type CategoryCreate = z.infer<typeof CategoryCreateSchema>;

export const CategoryUpdateSchema = z.object({
  name: z.string().min(1).max(200).optional(),
  description: z.string().max(2000).nullable().optional(),
  parentId: z.string().uuid().nullable().optional(),
  sort: z.number().int().min(0).max(1_000_000).optional(),
  isActive: z.boolean().optional(),
});
export type CategoryUpdate = z.infer<typeof CategoryUpdateSchema>;
